/*
@Samuai Nakak Scraping PHPuse
 */
"use strict";
(function($, win, doc) {
  var $doc, $win, getHtml, getHtml3;
  $win = $(win);
  $doc = $(doc);
  getHtml = function(data) {
    var $mediaTexts, $testDom;
    $mediaTexts = void 0;
    $testDom = $(data);
    $mediaTexts = $testDom.find("#testDom div.mediaText");
    return $mediaTexts.each(function(i) {
      $(this).addClass("clf");
      $(this).find(".hdr").wrap("<h4 class='' />");
      $("#testDomInner").append(this);
      return $("#testDomInner").append("<div class='ksen' />");
    });
  };
  getHtml3 = function(data) {
    var $mediaTexts, $testDom;
    $mediaTexts = void 0;
    $testDom = $(data);
    $mediaTexts = $testDom.find("#testDom3 div.mediaText");
    return $mediaTexts.each(function(i) {
      $(this).addClass("clf");
      $(this).find(".hdr").wrap("<h4 class='' />");
      $("#testDomInner3").append(this);
      return $("#testDomInner3").append("<div class='ksen' />");
    });
  };
  return $(function() {
    $.post("/php/example_basic_selector.php", {
      re: ""
    }, function(data) {
      return getHtml(data);
    });
    return $.post("/php/example_basic_selector3.php", {
      re: ""
    }, function(data) {
      return getHtml3(data);
    });
  });
})(jQuery, window, document);

